import React, { useState, useEffect } from 'react';

import MDParser from '../md-parser';

import './index.css';

const Component = (props) => {
    const { header, sectionID, mdURL } = props;

    let mdSource = mdURL;

    if (!mdURL.includes('://')) mdSource = `${process.env.PUBLIC_URL}/${mdURL}`;

    const [content, setContent] = useState('');

    useEffect(() => {
        // GET Source
        fetch(mdSource)
            .then((res) => res.text())
            .then((reply) => {
                setContent(reply);
            });
    }, []);

    return (
        <div id={sectionID} className="markdown-section">
            <h3>{header}</h3>
            <MDParser content={content} />
        </div>
    );
};

export default Component;
